import { FC } from "react";
import { styled } from "styled-components";

const StyledButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  display: flex;
  @media (min-width: 1150px) { // Dawn
    display: none;
  }
`;

interface Props {
  fill?: string;
  onClick: () => void;
}

const BurgerButton: FC<Props> = ({ onClick, fill = '#000' }) => (
  <StyledButton onClick={onClick}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" fill="none">
      <rect width="20" height="1.75" y="11" fill={fill} rx=".875" />
      <rect width="20" height="1.75" y="5.5" fill={fill} rx=".875" />
      <rect width="20" height="1.75" fill={fill} rx=".875" />
    </svg>
  </StyledButton>
);

export default BurgerButton;